<template>
  <v-container fluid class="theme-color" style="height: 100%; overflow-x:scroll;">
    <WaterReport />
  </v-container>
</template>

<script>
import WaterReport from '../components/water-executive/WaterReport.vue';

export default {
  name: 'WaterExecutive',
  components: {
    WaterReport
  },
  data: () => ({}),
  mounted() {
    this.$emit('gobacktolink', 'report-executive');
  },
  methods: {}
};
</script>
